export const appEndpoint = {
  getUser: `/getUser`,
  logout: '/logout',
  getUsers:'/users',
  addUser:'/users',
  updateUser:'/users',
  deleteUser: '/users',
  getBlogs:'/blogs',
  addBlog:'/blogs',
  updateBlog:'/blogs',
  deleteBlog: '/blogs',
  teamProfiles:'/team_profiles',
  subscribers:'/subscribers',
  changePassword:'/change-password',
  testimonials:'/testimonials',
  partners:'/partners',
  unitTypes:'/unit_types',
  dashboardSummary:'/dashboard/summary',
  contactMessages: '/contact_messages',
  newsLetters:'/newsletter',
  sendNewsletter:'/newsletter/send',
  legalDocuments:'/legal_documents',
  getGalleries:'/galleries',
  addGallery:'/galleries',
  updateGallery:'/galleries',
  deleteGallery: '/galleries',
  getCategories: '/categories',
  getPrograms: '/programs',
  addProgram: '/programs',
  updateProgram: '/programs',
  deleteProgram: '/programs',
  getImpacts: '/impacts',
  addImpact: '/impacts',
  updateImpact: '/impacts',
  deleteImpact: '/impacts',
  getVacancies: '/vacancies',
  addVacancy: '/vacancies',
  updateVacancy: '/vacancies',
  deleteVacancy: '/vacancies',
  getVolunteers: '/volunteers',
  addVolunteer: '/volunteers',
  updateVolunteer: '/volunteers',
  deleteVolunteer: '/volunteers',
  reorderTeamProfiles: '/team_profiles/reorder',
  getCSOMembers: '/cso_members',
  addCSOMember: '/cso_members',
  updateCSOMember: '/cso_members',
  deleteCSOMember: '/cso_members',
  getResourceDocuments: '/resource_documents',
  addResourceDocument: '/resource_documents',
  updateResourceDocument: '/resource_documents',
  deleteResourceDocument: '/resource_documents'
};